module.exports = __webpack_public_path__ + "img/banner02-desktop.226c4e28.webp";